import React from 'react';
import type { ChildrenProp, ClassNameProp } from '../common-types';

/**
 * Props for a {@link DocumentList} component. The children are meant to be {@link Document} components.
 */
export type DocumentListProps = Required<ChildrenProp> & ClassNameProp;

/**
 * Component meant for displaying a list of {@link Document}s.
 *
 * @param properties a {@link DocumentListProps} object. The children are meant to be {@link Document} components.
 * @constructor
 * @return the created {@link React.JSX.Element}
 */
export function DocumentList({
  children,
  className = '',
  ...props
}: Readonly<DocumentListProps>): React.JSX.Element {
  return (
    <div {...props} className={`ehs-document-list ${className}`.trim()}>
      {children}
    </div>
  );
}
